interface Props {
	level: number;
	maxStep: number;
}

export default function VolumeLevelBar({ level, maxStep }: Props) {
	return (
		<div className="flex">
			{Array.from({ length: maxStep }, (_, index) => {
				const isActiveStep = index < level;
				const baseClasses = "w-4 h-3 rounded-sm";

				if (isActiveStep) {
					return (
						<div key={index} className={`${baseClasses} bg-emerald-500 shadow-sm`} />
					);
				}
				return <div key={index} className={`${baseClasses} bg-white/10`} />;
			})}
		</div>
	);
}
